import React from "react";
import ReactWOW from "react-wow";

const Training = () => (
  <section id="training" className="white">
    <div className="container">
      <div className="section-title">
        <h2>Training Workshops</h2>
        {/* <p>Register for the competition and you will receive updates on upcoming training workshops. Please note that only successfully registered teams will receive invitations for the training workshops.</p> */}
        <p>
          Sign up for the challenge and indicate your interest during
          registration to be shortlisted for our training workshops! Shortlisted
          individuals will have the opportunity to attend free training
          workshops specially organised by Shopee. Confirmation will be sent to
          shortlisted individuals only.
        </p>
        <p>More details on the training workshops will be released soon!</p>
      </div>

      {/* <div className="flex-box">
        <ReactWOW animation="fadeInUp" delay="0.1s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                20th Feb <br />
                Introduction to Data Cleaning and Processing
              </h3>
              <strong>Part 1(15 mins):</strong>
              <p>Quick overview of Python and Pandas basics</p>
              <ul>
                <li>import / export data</li>
                <li>Standard Python Libraries</li>
                <li>Pandas Dataframe, aggregation and calculation</li>
              </ul>
              <strong>Part 2 (20 mins):</strong>
              <p>Data Cleaning and Extraction</p>
              <ul>
                <li>Filtering, Groupby, Merge</li>
                <li>Data Exploration</li>
              </ul>
              <strong>Part 3 (50 mins):</strong>
              <p>Hands On: Data Analysis on Customer Service chat data.</p>
              <ul>
                <li>Application of the above topics </li>
              </ul>
              <strong>Description:</strong>
              <p>
                Data comes in different shapes and forms but how can we process
                raw data such that it becomes useful for analysis and
                manipulation? This workshop will share on how Shopee Operations
                Customer Service department uses python to process and analyze
                data to help with making business decisions. Participants will
                have hands-on experience working on a dataset to process and
                gather insights from.
              </p>
              <strong>*Requirement:</strong>
              <p>
                Participants to have knowledge on basic programming concepts and
                access to python environment with pandas library{" "}
              </p>
              
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.2s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                21st Feb <br />
                Working with Data using Pandas
              </h3>
              <strong>Part 1(10 mins):</strong>
              <p>Overview of the Pandas library</p>
              <ul>
                <li>Data Structure: Series vs Dataframe</li>
                <li>Importing and Exporting Data</li>
              </ul>
              <strong>Part 2 (20 mins):</strong>
              <p>Common Functions and their Use Cases </p>
              <ul>
                <li>Basic Functions: View, Sort, Calculate</li>
                <li> Table Manipulation: Filter, Merge, Concatenate</li>
                <li>
                  {" "}
                  Data Aggregation: Group By, Pivot Table, Using Numpy Functions
                </li>
                <li> Defining New Functions: Apply and Lambda</li>
              </ul>
              <strong>Part 3 (50 mins):</strong>
              <p>Working with Payments data using Pandas </p>
              <ul>
                <li> Example of Payments Use Case</li>
                <li> Hand-on Exercise using above Functions</li>
              </ul>
              <strong>Description:</strong>
              <p>
                Many decisions made today are driven by data. Pandas is a very
                useful tool that allows us to easily import, clean, manipulate,
                analyse and finally export data. This workshop will share common
                functions used in Pandas and how this can be applied in the
                scope of Payments in Shopee. Participants will also get to apply
                the functions learnt on the dataset provided, with a realistic
                case to work on.
              </p>
              <strong>*Requirement:</strong>
              <p>
                Participants to have access to python environment with pandas
                library
              </p>
              
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.3s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                27th Feb <br />
                Machine Learning Application on Shopee Marketing Operation
              </h3>
              <strong>Part 1(20 mins):</strong>
              <ul>
                <li>
                  Overview of a general Machine Learning Project Framework
                </li>
                <li>Problem Statement</li>
                <li>Python Libraries Used for the exercise</li>
                <li>Description of data-set for the exercise</li>
              </ul>
              <strong>Part 2 (20 mins):</strong>
              <ul>
                <li>Model Training</li>
                <li>Train_Test Split</li>
                <li>Model Evaluation</li>
                <li>Model Tuning</li>
              </ul>
              <strong>Part 3 (40 mins):</strong>
              <p>Hands on model training and prediction</p>
              <ul>
                <li> Apply the model training to prepared dataset</li>
                <li> Evaluate the performance of models</li>
                <li>
                  {" "}
                  Model Tuning: See how you can drive more performance out of
                  the data
                </li>
                <li> Making predictions based on the trained model</li>
              </ul>
              <strong>Part 4 (10 mins):</strong>
              <ul>
                <li> Share the result</li>
                <li> {"Q&A"}</li>
              </ul>
              <strong>Description:</strong>
              <p>
                Machine learning (ML) helps with identifying patterns hidden in
                data and offers great benefits to e-commerce operations in areas
                such as marketing, logistics and fraud detection. In this
                workshop, we will share on how Shopee’s Business Intelligence
                team uses machine learning tools to help marketing teams run
                their operation more efficiently. Participants will learn how ML
                is applied in Shopee and have hands-on experience working on a
                dataset to train their own models.
              </p>
              <strong>*Requirement:</strong>
              <p>Participants are advised to have knowledge of python </p>
              
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.4s">
          <div className="box box-2 text-left">
            <div className="content">
              <h3>
                Ren Xingyu - 28th Feb <br />
                Machine Learning with ANN Using scikit-learn
              </h3>
              <strong>Part 1(10 mins):</strong>
              <p>What is Artificial Neural Network?</p>
              <ul>
                <li>The structure of Artificial Neural Network</li>
              </ul>
              <strong>Part 2 (40 mins):</strong>
              <p>How does Artificial Neural Network Work?</p>
              <ul>
                <li>Artificial Neural Network math foundations</li>
              </ul>
              <strong>Part 3 (30 mins):</strong>
              <p>Hands-on project on Artificial Neural Network</p>
              <ul>
                <li> Machine Learning with ANN Using scikit-learn</li>
              </ul>
              <strong>Description:</strong>
              <p>
                As Artificial Neural Network (ANN) and other machine learning
                methods have become increasingly fashionable in recent years
                computational techniques, it is worthwhile to get a closer look
                at the cognitive functions behind ANN. In this workshop, we will
                explore the mathematical foundation behind ANN and build our own
                ANN model based on real world data.
              </p>
              <strong>*Requirement:</strong>
              <p>Participants are advised to have basic calculus knowledge </p>
             
            </div>
          </div>
        </ReactWOW>
      </div> */}
    </div>
  </section>
);

export default Training;
